export default __webpack_public_path__ + "static/medialink-b5d1438ccde49670b7ada6e6c69ff90c.webp";